/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import FormHelperText from '@mui/material/FormHelperText';
import makeStyles from '@mui/styles/makeStyles';
import { Typography, Button, Box, CircularProgress } from '@mui/material';

import Styles from './styles';

const useStyles = makeStyles(Styles);

function ButtonGroup({ options, label, error, helperText, value, onChange, isLoading }) {
  const classes = useStyles();
  return (
    <>
      <div className={classes.selectorWrapper}>
        {isLoading && (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
            <CircularProgress />
          </Box>
        )}
        {!isLoading && options.length > 0 && (
          <FormControl className={classes.fieldSet} component="fieldset" error={error}>
            <div className={classes.wrapper}>
              {options.map(({ value: optionValue, label: optionLabel }) => (
                <Button
                  className={classes.slot}
                  data-testid="radio"
                  variant={value === optionValue ? 'contained' : 'outlined'}
                  size="medium"
                  key={optionValue}
                  onClick={() => onChange(optionValue)}
                >
                  <Typography variant="body2" component="span">
                    {optionLabel}
                  </Typography>
                </Button>
              ))}
            </div>
          </FormControl>
        )}
        {!isLoading && options.length <= 0 && (
          <FormLabel className={classes.timeSlotCaption} component="div">
            {label}
          </FormLabel>
        )}
      </div>
      <FormHelperText sx={{ color: 'red' }}>{helperText}</FormHelperText>
    </>
  );
}

ButtonGroup.propTypes = {
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  options: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.object), PropTypes.arrayOf(PropTypes.string)]),
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  error: PropTypes.bool,
  onChange: PropTypes.func,
  helperText: PropTypes.string,
  isLoading: PropTypes.bool,
};

ButtonGroup.defaultProps = {
  error: false,
  helperText: '',
  options: [],
  value: '',
  onChange: () => {},
  isLoading: false,
};

export default ButtonGroup;
